import { cva } from "class-variance-authority";

export { default as Input } from "./Input.vue";

export const inputVariants = cva(
  "flex w-full rounded-md border border-input bg-transparent shadow-sm transition-colors file:border-0 file:bg-transparent file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      size: {
        xs: "h-7 px-2 py-1 text-xs file:text-xs",
        sm: "h-8 px-2.5 py-1 text-sm file:text-sm",
        default: "h-9 px-3 py-1 text-sm file:text-sm",
        lg: "h-10 px-4 py-2 text-base file:text-base",
        xl: "h-12 px-4 py-3 text-lg file:text-lg",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);
